import { render } from "./WhatsAppIcon.vue?vue&type=template&id=152a7d34&scoped=true&ts=true"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=ts"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=ts"

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=152a7d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152a7d34"]])

export default __exports__